import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post } from '../modules/category'

import component from 'components/Categories/New'

const formName = 'new-category'
const fields = ['name', 'desc', 'priority', 'hidden']

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  onSubmit: (data) => {
    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, {}, fields))
  }
})

const mapStateToProps = (state) => ({
  category: state.category
})

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Categories/containers/NewCategoryContainer.js